import { Link, useLocation } from "react-router-dom";
import { getUserRoleFromToken } from '../utils/getUserRoleFromToken';

function Navbar() {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const userRole = getUserRoleFromToken(token);
  const isAdmin = userRole === "admin";

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        // Clock out
        await fetch('/api/time/clockout', {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${token}` }
        }).catch(() => {});
        // Stop any active work
        await fetch('/api/work/stop', {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${token}` }
        }).catch(() => {});
      }
    } finally {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
  };


  if (!token) return null;

  return (
    <nav className="w-full bg-white border-b border-gray-200 shadow-sm flex items-center px-8 h-14 fixed top-0 left-0 z-20">
      <div className="flex gap-6 font-semibold text-gray-700">
        <Link
          to="/"
          className={`hover:text-blue-500 transition ${
            location.pathname === "/" ? "text-blue-600 underline" : ""
          }`}
        >
          Home
        </Link>
        <Link
          to="/projects"
          className={`hover:text-blue-500 transition ${
            location.pathname === "/projects" ? "text-blue-600 underline" : ""
          }`}
        >
          Projects
        </Link>
        <Link
          to="/timework"
          className={`hover:text-blue-500 transition ${
            location.pathname === "/timework" ? "text-blue-600 underline" : ""
          }`}
        >
          Time Entries
        </Link>
        {isAdmin && (
          <Link
            to="/admin/workers"
            className={`hover:text-blue-500 transition ${
              location.pathname === "/admin/workers" ? "text-blue-600 underline" : ""
            }`}
          >
            Workers
          </Link>
        )}
      </div>
      <div className="ml-auto">
        <button
          className="bg-gray-100 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded border border-gray-400"
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
